export default "__VITE_ASSET__996e4a87__"